<template>
  <v-btn-toggle group>
    <v-btn text class="ma-0" router to='/customers'>Customers</v-btn>
    <v-btn text class="ma-0" router to='/find-user'>Users</v-btn>
    <v-btn text class="ma-0" router to='/apps'>Apps</v-btn>
    <v-btn text class="ma-0" router to='/versions'>Versions</v-btn>

    <!-- Dropdown Menu -->
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn text class="ma-0" v-on="on">More <v-icon right>mdi-menu-down</v-icon></v-btn>
      </template>

      <v-list>
        <v-list-item link :to="'/feature-intro'">Feature Introduction</v-list-item>
        <v-list-item link :to="'/signin-history'">App Usage History</v-list-item>
      </v-list>
    </v-menu>
  </v-btn-toggle>
</template>

<script>
export default {
  name: 'SuperUserMenuLinks',
};
</script>

<style lang="scss">
</style>
